import { Environment } from '../../../environments/environment';

export interface AvailableAreaParamsType {
  active: boolean;
  community: string;
  fields: string;
  homefinderEnabled: boolean;
  id?: string;
  offset: number;
}

export function AvailableAreasParams(): AvailableAreaParamsType {
  return {
    active: true,
    community: Environment.community,
    fields: 'title,color',
    homefinderEnabled: true,
    offset: 0,
  };
}
